import { createStore } from "vuex";
import auth from "./modules/auth";
import notificator from "./modules/notificator";
import users from "./modules/users";
import operations from "./modules/operations";

export interface State {
  isLoading: boolean;
  openDrawer: boolean;
}

const debug = process.env.NODE_ENV !== "production";

export default createStore({
  strict: debug,
  modules: { auth, notificator, users, operations },
  state: {
    isLoading: false,
    openDrawer: true,
  },
  mutations: {
    SET_LOADING(state: State, payload: boolean) {
      state.isLoading = payload;
    },
    toggleDrawer(state: State) {
      state.openDrawer = !state.openDrawer;
    },
    setDrawerOpen(state: State, isOpen: boolean) {
      state.openDrawer = isOpen;
    },
  },
  actions: {
    SET_LOADING({ commit }, payload: boolean) {
      commit("SET_LOADING", payload);
    },
  },
});
